var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",class:{
    'safe-padding': _vm.showSafePadding,
    'justify-height': _vm.keyboardChange,
    'hide-header': _vm.hideHeader
  }},[(!_vm.hideHeader)?_c('div',{staticClass:"page-header"},[(!_vm.hideBack)?_c('Back',{staticClass:"page-header-back"}):_vm._e(),_c('h1',{staticClass:"page-header-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.isInSdk)?_c('Close',{staticClass:"page-header-close",on:{"click":this.closeWebview}}):_vm._e()],1):_vm._e(),_c('div',{staticClass:"page-main"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }